import styled from "styled-components";

export const Container = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
	grid-gap: 15px;
	margin-bottom: 15px;

	& > button {
		display: inline-block;
		border: none;
		border: 1px solid #ddd;
		border-radius: 4px;
		padding: 10.5px 5px 9px 5px;
		margin: 0;
		margin-top: 5px;
		text-decoration: none;
		background: transparent;
		background-color: #fff;
		font-family: inherit;
		font-size: 1.1rem;
		cursor: pointer;
		appearance: none;
		-webkit-appearance: none;
		-moz-appearance: none;
		outline: none;
		transition: all 0.3s;
		color: inherit;

		&:hover,
		&.selected {
			background-color: var(--primarycolor);
			border-color: var(--primarycolor);
			color: #fff;
		}
	}
`;
